import { axios } from "lib";

const getInfo = ()=>{
    return  axios.get('/anonymous/sos/list')
}

export {getInfo}